import { render, staticRenderFns } from "./dashboardPage.vue?vue&type=template&id=4fae2c57&scoped=true"
import script from "./dashboardPage.vue?vue&type=script&lang=js"
export * from "./dashboardPage.vue?vue&type=script&lang=js"
import style0 from "./dashboardPage.vue?vue&type=style&index=0&id=4fae2c57&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fae2c57",
  null
  
)

export default component.exports